
import React from 'react';
import './ScoreRing.css';

type ScoreRingProps = {
  score: number; // 0-100
  size?: number;
  label?: string;
  tone?: 'good' | 'warn' | 'bad';
};

export const ScoreRing: React.FC<ScoreRingProps> = ({
  score,
  size = 96,
  label,
  tone = 'good',
}) => {
  const clampScore = Math.max(0, Math.min(100, score));
  const strokeWidth = 7;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (clampScore / 100) * circumference;

  return (
    <div className="score-ring-wrapper" style={{ width: size, height: size }}>
      <svg
        className="score-ring-svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        <circle
          className="score-ring-bg"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          className={`score-ring-progress score-ring-${tone}`}
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="score-ring-center">
        <div className="score-ring-score">{clampScore}</div>
        <div className="score-ring-label">
          {label ?? (clampScore >= 85 ? '优秀' : clampScore >= 70 ? '良好' : clampScore >= 50 ? '需提升' : '警示')}
        </div>
      </div>
    </div>
  );
};
